<div class="btn-back-div">
  <usimweb-button-icon [icon]="'arrow_back'" fontColor="white" (btnClick)="back()"></usimweb-button-icon>
</div>

<div *ngIf="title" style="position: absolute; top: 40px; text-align: center; width: 100%">
  <p style="margin-top: 0px; color: #000000; font-size: 18px; font-weight: bold">
    New simulation in Project:
    <u>{{ title }}</u>
  </p>
</div>

<div class="container-fluid space">
  <form name="form" novalidate>
    <mat-horizontal-stepper #stepper style="margin-top: 100px">
      <mat-step [stepControl]="formGroup">
        <ng-template matStepLabel>Part</ng-template>

        <div class="step-container">
          <div class="row">
            <div class="col-md-12 col-xl-6 col">
              <app-part
                [meshes]="meshes"
                [part]="part"
                (updatePart)="updatePart($event)"
                (requestModel)="openModel($event)"
                (openModel)="getGeometry($event)"
              ></app-part>
            </div>
            <div class="col-md-12 col-xl-6 col col-padding preview-col">
              <div class="rectangle preview-box">
                <usimweb-progress-spinner
                  *ngIf="isPrevLoading"
                  class="spinner"
                  [diameter]="40"
                  [mode]="'indeterminate'"
                ></usimweb-progress-spinner>
                <div id="vtkjsPreviewDiv">
                  <h3 *ngIf="!vtkpreview" style="text-align: center; margin-top: 150px">No preview geometry</h3>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="center">
          <usimweb-button-navigate text="Next" type="button" navigateAction="next">Next</usimweb-button-navigate>
        </div>
      </mat-step>

      <mat-step [stepControl]="formGroup">
        <ng-template matStepLabel>Material</ng-template>

        <div class="step-container">
          <div class="row">
            <div class="col-md-12 col-xl-6">
              <app-material
                [foams]="foams"
                (selectionChangeMaterial)="updateMaterial($event)"
                (selectionChangeUsimData)="drawPlot($event)"
              ></app-material>
            </div>
            <div class="col-md-12 col-xl-6 col col-padding preview-col">
              <!-- <usimweb-plot
                divId="densityContainer"
                (initialized)="onInitialized()"
                [data]="densityViscoChart"
                [layout]="densityViscoLayout">
              </usimweb-plot> -->
              <plotly-plot
                divId="densityContainer"
                (initialized)="onInitialized()"
                [data]="densityViscoChart"
                [layout]="densityViscoLayout"
                [revision]="0"
              ></plotly-plot>
            </div>
          </div>
        </div>

        <div class="center">
          <usimweb-button-navigate class="btn-space" text="Back" navigateAction="previous"></usimweb-button-navigate>
          <usimweb-button-navigate text="Next" navigateAction="next"></usimweb-button-navigate>
        </div>
      </mat-step>

      <mat-step [stepControl]="formGroup">
        <ng-template matStepLabel>Process data</ng-template>

        <div class="step-container">
          <div class="row">
            <div class="col-md-12 col-xl-6">
              <app-process-data
                [volume]="volume"
                [freeRiseDensity]="freeRiseDensity || 0"
                (selectionChangeDensity)="addTargetDensity($event)"
                (injectionTimeChanged)="addInjectionTime($event)"
                (updateProcessData)="updateProcessData($event)"
              ></app-process-data>
            </div>
            <div class="col-md-12 col-xl-6 col col-padding preview-col">
              <plotly-plot
                divId="densityContainer"
                (initialized)="onInitialized()"
                [data]="densityViscoChart"
                [layout]="densityViscoLayout"
                [revision]="0"
              ></plotly-plot>
            </div>
          </div>
        </div>

        <div class="center">
          <usimweb-button-navigate class="btn-space" text="Back" navigateAction="previous"></usimweb-button-navigate>
          <usimweb-button-navigate text="Next" navigateAction="next"></usimweb-button-navigate>
        </div>
      </mat-step>

      <mat-step *ngIf="isOpenMold" [stepControl]="formGroup">
        <ng-template matStepLabel>Open mold</ng-template>

        <div class="step-container">
          <app-open-mold
            [density]="initialDensity || 0"
            [injectionRate]="processData.injectionRate"
            [injectionTime]="injectionTime"
            [modelId]="viewer"
            [gravity]="gravity"
            (selectionChanged)="updateOpenMold($event)"
            (moldClosingChanged)="moldClosingChanged($event)"
          ></app-open-mold>
        </div>

        <div class="center">
          <usimweb-button-navigate class="btn-space" text="Back" navigateAction="previous"></usimweb-button-navigate>
          <usimweb-button-navigate text="Next" navigateAction="next"></usimweb-button-navigate>
        </div>
      </mat-step>

      <mat-step *ngIf="isBoundaryPart" [stepControl]="formGroup">
        <ng-template matStepLabel>Boundary part</ng-template>

        <div class="step-container">
          <div class="row">
            <div class="col-7">
              <!-- <app-boundary-part [boundingBoxParts]="boundingBoxParts"></app-boundary-part> -->
            </div>
            <div class="col col-5">
              <!-- <app-shared-viewer *ngIf="loadViewerThree" [modelId]="viewerThree"></app-shared-viewer> -->
            </div>
          </div>
        </div>
      </mat-step>

      <!-- <mat-step [stepControl]="formGroup">
        <ng-template matStepLabel>Boundary Conditions</ng-template>

        <div class="step-container-90">
          <app-boundary-conditions></app-boundary-conditions>
        </div>
      </mat-step> -->

      <mat-step [stepControl]="formGroup">
        <ng-template matStepLabel>Simulate</ng-template>

        <div class="step-container">
          <div class="row">
            <div class="col-md-12 col-xl-6">
              <app-simulate
                [cpus]="cpus"
                [appType]="simulate.appType"
                [defaultCpu]="defaultCpu"
                [credits]="credits"
                (selectionChangeSimTime)="addSimulationTime($any($event))"
                (updateSimulate)="updateSimulate($any($event))"
              ></app-simulate>
            </div>
            <div class="col-md-12 col-xl-6 col col-padding preview-col">
              <plotly-plot
                divId="densityContainer"
                (initialized)="onInitialized()"
                [data]="densityViscoChart"
                [layout]="densityViscoLayout"
                [revision]="0"
              ></plotly-plot>
            </div>
          </div>
        </div>

        <div class="center">
          <usimweb-button-navigate class="btn-space" text="Back" navigateAction="previous"></usimweb-button-navigate>
          <usimweb-button-navigate
            class="btn-space"
            text="Simulate"
            navigateAction="none"
            (btnClick)="openStartSimulationDialog()"
          ></usimweb-button-navigate>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </form>
</div>
